module.exports = __webpack_public_path__ + "static/media/logo-pictogram.25dae3b5.svg";